import { FtuxConfig, FtuxStep } from '../types';
import { ensureLastStepIsDone } from './utils';

interface TeacherManagementConfigOptions {}

export const getTeacherManagementConfig = (options: TeacherManagementConfigOptions = {}): FtuxConfig => {
	const steps: FtuxStep[] = [
		{
			type: 'modal' as const,
			title: 'Teacher support',
			subtitle:
				'Access additional information about the Little Learners program, along with support for implementing it with fidelity. Browse blogs and watch webinars to learn something new or revisit and refresh your skills on a specific topic.',
			image: '/img/ftux-support-1.png',
			button: {
				label: 'Got it',
				type: 'paginated' as const
			},
			modalPosition: 'bottom-right' as const,
			hasBackdrop: false
		}
	];

	const config: FtuxConfig = {
		id: 'teacher-management-ftux',
		name: 'Teacher Management Tutorial',
		showSkipButton: false,
		steps
	};

	// Ensure the last step always has "Done" as the label
	return ensureLastStepIsDone(config);
};
